import { HttpResponse } from '@angular/common/http';

import { ApiOptions } from '../../api-options.decorator';
import { ParamsAdapter } from '../../params.adapter';

import { ApiBaseMidBack } from './base';
import { CertificateOperationViewModel } from './types/certificateOperationViewModel';

/**
 * @internal
 */
export class ApiCertificateOperations extends ApiBaseMidBack {
  @ApiOptions({ interceptErrors: false })
  certificateOperations(params: ParamsAdapter) {
    return this.get<CertificateOperationViewModel[]>('/certificate-operations', params);
  }

  @ApiOptions({ interceptErrors: false })
  postCertificateOperations(body: ParamsAdapter) {
    return this.post<CertificateOperationViewModel>('/certificate-operations', body);
  }

  @ApiOptions({ interceptErrors: false, responseType: 'blob', responseObserve: 'response' })
  exportGoosPositions(params: ParamsAdapter) {
    return this.get<HttpResponse<Blob>>('/certificate-operations/positions/export/excel', params);
  }

  @ApiOptions({ interceptErrors: false, responseType: 'blob', responseObserve: 'response' })
  exportGoosRedemption(params: ParamsAdapter) {
    return this.get<HttpResponse<Blob>>('/certificate-operations/redemption/export/excel', params);
  }
}
